<template>
    <div class="full-search-2 eclip-search italian-search hero-search-radius shadow mt-5">
        <div class="hero-search-content">
            <div class="row">
                <div class="col-lg-4 col-md-3 col-sm-12">
                    <div class="form-group borders border-start">
                        <div class="position-relative ps-5">
                            <Multiselect v-model="selectedCategory" :options="categories" :no-options-text="t('noOptions')" :placeholder="t('Category')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z" fill="currentColor"/>
                                        <path d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-3 col-sm-12" >
                    <div class="form-group borders border-start">
                        <div class="position-relative ps-5">
                            <Multiselect v-model="selectedState" :options="states" :no-options-text="t('noOptions')" :placeholder="t('State')" class="form-control px-0 border-0" append-to-body open-direction="bottom" :class="{'rtl-direction': $i18n.locale === 'ar', 'ltr-direction': $i18n.locale === 'en'}" />
                            <div class="position-absolute top-50 start-0 translate-middle-y ms-2">
                                <span class="svg-icon text-primary svg-icon-2hx">
                                    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"/>
                                        <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-2 col-sm-12">
                    <div class="form-group">
                        <button type="button" @click="searchAds" class="btn btn-primary fw-medium full-width">{{ t('Search') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/default.css';
import { ref, watch } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import {useI18n} from "vue-i18n";
const router = useRouter();
const  {t} = useI18n();
const { locale } = useI18n();
const states = ref([]);
const categories = ref([]);
const selectedCategory = ref(null);
const selectedState = ref(null);
const loading = ref(false);
const fetchStates = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-states`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedStates = response.data.states || [];
    states.value = fetchedStates.map(state => ({
      label: state.name,
      value: state.id
    }));
  } catch (error) {
    console.error("Error fetching states:", error);
  } finally {
    loading.value = false;
  }
};
const fetchCategories = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/get-categories`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedCategories = response.data.categories || [];
    categories.value = fetchedCategories.map(category => ({
      label: category.name,
      value: category.id
    }));
  } catch (error) {
    console.error("Error fetching categories:", error);
  } finally {
    loading.value = false;
  }
};

watch(locale, fetchStates, { immediate: true });
watch(locale, fetchCategories, { immediate: true });



const searchAds = () => {
    router.push({
        path: "/Ads/search",
        query: {
            category_id: selectedCategory?.value || '',
            state_id: selectedState?.value || ''
        }
    });
};
watch(locale, (newLocale) => {
  const direction = newLocale === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', direction);
}, { immediate: true });
</script>
<style scoped>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
</style>

<style>
@media (max-width: 768px) {
  .multiselect {
    width: 100%;
    font-size: 16px;
  }
}
.multiselect-option.is-selected {
  background-color: #6A715D;
  color: white;
}
.multiselect-option {
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-size: var(--ms-option-font-size, 1rem);
    justify-content: flex-start;
    line-height: var(--ms-option-line-height, 1.375);
    padding: var(--ms-option-py, .5rem) var(--ms-option-px, .75rem);
    text-align: left;
    text-decoration: none;
}

html[dir="rtl"] .multiselect-option {
  direction: rtl;
  text-align: right;
}

html[dir="ltr"] .multiselect-option {
  direction: ltr;
  text-align: left;
}
.multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed, #578F33 );
    color: var(--ms-option-color-selected-pointed, #fff);
}
</style>